module.exports = __webpack_public_path__ + "static/media/light_jeff.093c2adb.jpg";